<template>
  <Splitpanes class="default-theme">
    <slot />
  </Splitpanes>
</template>

<script>
export default {
  name: "EgSplitpanes",
};
</script>

<style lang="scss" scoped>
.splitpanes__pane {
  background: white !important;
}

.splitpanes::v-deep .splitpanes__splitter {
  width: 3px !important;
  position: relative !important;

  &::before {
    content: "\f180" !important;
    font-family: "eg-icons";
    font-size: 26px !important;
    position: absolute !important;
    left: 50% !important;
    transform: translateX(-54%) !important;
    width: 26px !important;
    height: 26px !important;
    border: 1px solid var(--color-stroke-neutral-default) !important;
    color: var(--colors-gray-400) !important;
    border-radius: 50% !important;
    background-color: #f6f8fa !important;
    margin-left: 1px !important;
    z-index: 1000 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &::after {
    content: "" !important;
    background: transparent !important;
  }

  &:hover::before {
    background-color: var(--colors-purple-500) !important;
    border: 1px solid var(--colors-purple-500) !important;
    color: white !important;
  }
  &:hover {
    background-color: var(--colors-purple-500) !important;
    border: 1px solid var(--colors-purple-500) !important;
  }
}
</style>
